import { Alert, Box } from '@mui/material';
import { EmbeddedFooterImageTab } from 'app/pages/ContentManagementPage/components/footerImage/FooterImageTab';

type FooterImageEntityPanelProps = {
  dealerId: string;
  allowedIds: string[];
};

export default function FooterImageEntityPanel({
  dealerId,
  allowedIds,
}: FooterImageEntityPanelProps) {
  if (!allowedIds.length) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        No footer image IDs were provided for this attention row.
      </Alert>
    );
  }

  if (!dealerId.trim()) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        Select a dealer to view footer images.
      </Alert>
    );
  }

  return (
    <Box sx={{ minHeight: 0, flex: 1, overflow: 'hidden' }}>
      <EmbeddedFooterImageTab embedded allowedRowIds={allowedIds} />
    </Box>
  );
}
